export const percentualNumberChange = (
  number: number | null | undefined,
  percentValue: number | null | undefined,
) => {
  return typeof number === "number" && typeof percentValue === "number"
    ? Number((number * (percentValue / 100 + 1)).toFixed(6))
    : null;
};
